import { render, staticRenderFns } from "./FetchingSpinnerOverlay.vue?vue&type=template&id=1779c0a2&scoped=true&"
import script from "./FetchingSpinnerOverlay.vue?vue&type=script&lang=ts&"
export * from "./FetchingSpinnerOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./FetchingSpinnerOverlay.vue?vue&type=style&index=0&id=1779c0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1779c0a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1779c0a2')) {
      api.createRecord('1779c0a2', component.options)
    } else {
      api.reload('1779c0a2', component.options)
    }
    module.hot.accept("./FetchingSpinnerOverlay.vue?vue&type=template&id=1779c0a2&scoped=true&", function () {
      api.rerender('1779c0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FetchingSpinnerOverlay.vue"
export default component.exports